import { axiosInstancePlano } from '../../../../core/api/planoAxios';
import { IScheduleInfo, ISSRPeriod, IWeekSchedule, IWeekScheduleDetailed, IWeekScheduleGrouped, IWeekScheduleGroupedSubjects } from '../../model/weekSchedule';
import { useAuxScheduleStore } from '../../stores/useAuxScheduleStore';

export const getWeekSchedule = async (cronograma_id: string, week: number): Promise<IWeekSchedule> => {
  try {   
    const { data } = await axiosInstancePlano.get(`/cronograma/${cronograma_id}/semana/${week}`);
        
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export const getWeekScheduleDetailed = async (cronograma_id: string, week: number): Promise<IWeekScheduleDetailed> => {
    try {
        const { data } = await axiosInstancePlano.get(`/cronograma/${cronograma_id}/semana/${week}/detalhado`);
        
        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const getWeekScheduleGrouped = async (cronograma_id: string, week: number): Promise<IWeekScheduleGrouped> => {
    try {
        const { data } = await axiosInstancePlano.get(`/cronograma/${cronograma_id}/semana/${week}/agrupado`);

        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const getWeekScheduleGroupedSubjects = async (
  cronograma_id: string,
  week: number,
  day?: string
): Promise<IWeekScheduleGroupedSubjects> => {
    try {
        const dayPath = day ? `/${encodeURIComponent(day)}` : '';
        const { data } = await axiosInstancePlano.get(`/cronograma/${cronograma_id}/semana/${week}/agrupado-subjects${dayPath}`);

        return data;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const getScheduleInfo = async (cronograma_id: string): Promise<IScheduleInfo> => {
  try {
    const setWeekSchedule = useAuxScheduleStore.getState().setWeekSchedule;

    const { data } = await axiosInstancePlano.get(`/cronograma/${cronograma_id}/resumo`);

    if(data) {
      setWeekSchedule({
        title: data.nome,
        weeks: data.semanas,
        weekTime: data.horasEstudos
      })
    }

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export const markAsCompleted = async (cronograma_id: string, conteudo: string): Promise<any> => {
    try {
        const response = await axiosInstancePlano.post(`/cronograma/${cronograma_id}/concluir`, {
            idCronograma: cronograma_id,
            conteudosIds: [conteudo]
        });
        
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const markAsFavorite = async (cronograma_id: string, conteudo: string): Promise<any> => {
  try {
    const response = await axiosInstancePlano.post(`/cronograma/${cronograma_id}/favoritar`, {
      idCronograma: cronograma_id,
      conteudosIds: [conteudo]
    });
        
    return response;
  } catch (error: any) {
    throw new Error(error);
  }
}

export const createScheduleSSR = async (cronogramaId: string, period?: ISSRPeriod): Promise<any> => {
  try {
    const { data } = await axiosInstancePlano.post(`/ssr/create/${cronogramaId}`, period ?? {});

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export const markDiscursiveExerciseAsDone = async (cronogramaId: string, exerciseId: string): Promise<any> => {
  try {
    const { data } = await axiosInstancePlano.post(`/cronograma/${cronogramaId}/exercicio/discursivo/${exerciseId}/concluir`);

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
}